export enum ENotificationType {
  Message = 1,
  Notification,
}
